function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#B6B6B6",
  fillRule: "evenodd",
  d: "M.226 2.682a.941.941 0 011.327-.103l12.235 10.353a.941.941 0 01-.612 1.656.941.941 0 01-.64-.188l-2.183-1.882a6.758 6.758 0 01-2.824.658c-4.451 0-7.34-4.734-7.435-4.931a.499.499 0 010-.49 13.355 13.355 0 011.882-2.353L.33 4.01a.941.941 0 01-.103-1.327zm4.48 5.054a2.259 2.259 0 000 .264 2.824 2.824 0 002.823 2.824c.236-.003.47-.038.697-.104zm2.823-4.912c4.452 0 7.342 4.734 7.464 4.931a.499.499 0 01.019.49 13.365 13.365 0 01-1.657 2.099l-3.002-2.542a2.824 2.824 0 00-2.824-2.626 2.259 2.259 0 00-.263 0L5.045 3.294a6.588 6.588 0 012.484-.47z"
});

function SvgEyeDisable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _ref);
}

export default SvgEyeDisable;